import React from 'react';
import _HomeBanner from './_HomeBanner.scss';
import CONFIG from 'base/constants/config';
import { ShowIf } from 'components/utils';
import Slider from 'slider';
import {CategoryMenu} from 'components/category';
import moment from 'moment';
import {connect} from 'react-redux';

class HomeBanner extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      banners: [],
      name: '',
      startDate: '',
      endDate: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.SystemInfo !== this.props.SystemInfo) {
      this.forceUpdate()
    }
  }

  render() {
    let { SystemInfo } = this.props;
    const settings = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplaySpeed: 5000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: false
          }
        }
      ]
    };
    return (
      <div className='home-banner-wrapper' id='homeBanner'>
        <div className='wrap-category-menu'>
          <CategoryMenu/>
        </div>
        { SystemInfo && SystemInfo.banners && (<Slider {...settings}>
          {
            SystemInfo && SystemInfo.banners && SystemInfo.banners.map((item, i) => {
              return(
                <img className='home-banner' key={i} src={`${CONFIG.VITRADE_IMAGE_URL}/resize/1440x810/fairs/download/${item || ''}`} />
              )
            })
          }
        </Slider>)}
        <ShowIf condition={SystemInfo.banners && SystemInfo.banners.length === 0 || !SystemInfo.banners}>
          <img className='home-banner' src={require('assets/images/home-banner/banner.png')} />
        </ShowIf>
        {/*<div className='content-banner'>
          <h2 className='fair-name'>{name}</h2>
          <h2 className='fair-time'><span>Diễn ra từ {moment(startDate).format('DD/MM/YYYY')}&nbsp;</span><span>đến {moment(endDate).format('DD/MM/YYYY')}</span></h2>
        </div>*/}
      </div>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};

export default connect(bindStateToProps)(HomeBanner);



// WEBPACK FOOTER //
// ./components/home/sub-view/HomeBanner.jsx